function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import SearchableListInput from "./SearchableListInput";
import Box from "../Box";
const SearchableSelectPrefixedInput = config => {
  const {
    prefix
  } = config;
  class _SearchableListInputProps extends React.Component {
    constructor(...args) {
      super(...args);
      // @ts-expect-error - TS2564 - Property 'input' has no initializer and is not definitely assigned in the constructor.
      this.input = void 0;
      this.inputRef = node => {
        // @ts-expect-error - TS2322 - Type 'typeof SearchableListInput | null' is not assignable to type 'SearchableListInput | null'.
        this.input = node;
      };
    }
    focus() {
      if (this.input) {
        this.input.focus();
      }
    }
    render() {
      return /*#__PURE__*/React.createElement(Box, {
        flex: {
          alignItems: 'flex-start'
        },
        className: "SearchableList-input"
      }, /*#__PURE__*/React.createElement("div", null, prefix), /*#__PURE__*/React.createElement(SearchableListInput, _extends({}, this.props, {
        className: "",
        style: {
          border: 'none',
          outline: 'none',
          paddingLeft: '5px'
        }
        // @ts-expect-error - TS2769 - No overload matches this call.
        ,
        ref: this.inputRef
      })));
    }
  }
  return _SearchableListInputProps;
};
export default SearchableSelectPrefixedInput;